import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-toast-notifications-progress',
  styleUrls: ['./toast-notifications-progress.component.scss'],
  templateUrl: './toast-notifications-progress.component.html',
  standalone: false
})
export class ToastNotificationsProgressComponent implements OnInit {
  @Input() duration: number;
  progress = 0;

  ngOnInit(): void {
    const x = setInterval(() => {
      this.progress = this.progress + 0.01;
      if (this.progress >= 1) {
        clearInterval(x);
      }
    }, this.duration / 100);
  }
}
